import React from 'react';
import { applyTypography } from '@repo/common';

/**
 * @example
 * <PathfinderQuestionHeader
 *   progressLabel="Question 1/7"
 *   title="최근 5년 내 가장 관련 있는 경험은 무엇인가요?"
 *   helperText="다중 선택 가능"
 * />
 */
function PathfinderQuestionHeader({
  progressLabel,
  title,
  helperText = '',
  className = '',
}) {
  return (
    <div className={`flex w-full flex-col items-start gap-3 pb-[50px] ${className}`}>
      <div className='flex w-full flex-col items-center'>
        <div className='rounded-[30px] bg-green-light01 px-2 py-1'>
          <span
            className={`text-center text-green-deep02 ${applyTypography(
              'b12Strong',
              progressLabel
            )}`}
          >
            {progressLabel}
          </span>
        </div>
      </div>

      <h1
        className={`w-full text-center text-text-primary ${applyTypography(
          'h6',
          title
        )}`}
      >
        {title}
      </h1>

      {helperText ? (
        <p
          className={`w-full text-center text-text-placeholder ${applyTypography(
            'b16',
            helperText
          )}`}
        >
          {helperText}
        </p>
      ) : null}
    </div>
  );
}

export default PathfinderQuestionHeader;
